import React from 'react'

export default function Whiteboard(props) {
  return (
    <div>
      <iframe title="whiteboard" src={`https://ecswb.virtusasystems.com/?whiteboardid=${props.subCode}`} frameborder="0" style={{ width: "100vw", height: "90vh" }}></iframe>
    </div>
  )
}